var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsNavbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6847 15.3942C14.3851 15.3942 15.7636 14.0157 15.7636 12.3153C15.7636 10.6148 14.3851 9.23633 12.6847 9.23633C10.9842 9.23633 9.60571 10.6148 9.60571 12.3153C9.60571 14.0157 10.9842 15.3942 12.6847 15.3942Z",
    stroke: "#949699",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42114 13.2213V11.415C2.42114 10.3476 3.29351 9.46499 4.37114 9.46499C6.22877 9.46499 6.98825 8.15131 6.0543 6.53999C5.52062 5.61631 5.83877 4.41552 6.77272 3.88184L8.54825 2.86578C9.35904 2.38342 10.4059 2.67078 10.8882 3.48157L11.0011 3.67657C11.9248 5.28789 13.4438 5.28789 14.3777 3.67657L14.4906 3.48157C14.973 2.67078 16.0198 2.38342 16.8306 2.86578L18.6061 3.88184C19.5401 4.41552 19.8582 5.61631 19.3246 6.53999C18.3906 8.15131 19.1501 9.46499 21.0077 9.46499C22.0751 9.46499 22.9577 10.3374 22.9577 11.415V13.2213C22.9577 14.2887 22.0854 15.1713 21.0077 15.1713C19.1501 15.1713 18.3906 16.485 19.3246 18.0963C19.8582 19.0303 19.5401 20.2208 18.6061 20.7545L16.8306 21.7705C16.0198 22.2529 14.973 21.9655 14.4906 21.1547L14.3777 20.9597C13.454 19.3484 11.9351 19.3484 11.0011 20.9597L10.8882 21.1547C10.4059 21.9655 9.35904 22.2529 8.54825 21.7705L6.77272 20.7545C5.83877 20.2208 5.52062 19.02 6.0543 18.0963C6.98825 16.485 6.22877 15.1713 4.37114 15.1713C3.29351 15.1713 2.42114 14.2887 2.42114 13.2213Z",
    stroke: "#949699",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNavbar);
export default __webpack_public_path__ + "static/media/settings-navbar.68cf32f52f010fa58cc3236bff0aa731.svg";
export { ForwardRef as ReactComponent };